import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
	EmailSenderType,
	ReplyToType,
} from '@/modules/notification-templates/types'

import { MEETING_NOTIFICATIONS_VIEW_PREFERENCES_KEY } from '../constants/view'
import { MeetingNotificationsSortByOptions } from '../pages/MeetingNotificationsHome/components/SortBy'
import {
	MeetingNotificationTemplateType,
	MeetingNotificationTemplateTypeEnum,
} from '../types'
import { ViewTypes } from '../types/ViewTypes'

const localViewPreferences = localStorage.getItem(
	MEETING_NOTIFICATIONS_VIEW_PREFERENCES_KEY,
) as ViewTypes

interface MeetingNotificationsTemplatesState {
	meetingNotificationsViewPreferences: ViewTypes | null
	sortBy: MeetingNotificationsSortByOptions | null
	meetingNotificationTemplate: MeetingNotificationTemplateType | null
	search: string
	filterByType: MeetingNotificationTemplateTypeEnum | null
}

export const initialState: MeetingNotificationsTemplatesState = {
	meetingNotificationsViewPreferences: localViewPreferences || ViewTypes.list,
	sortBy: null,
	meetingNotificationTemplate: null,
	search: '',
	filterByType: null,
}

export const meetingNotificationsTemplatesSlice = createSlice({
	name: 'meeting-notifications-templates',
	initialState,
	reducers: {
		setMeetingNotificationTemplate: (
			state,
			action: PayloadAction<MeetingNotificationTemplateType | null>,
		) => {
			state.meetingNotificationTemplate = action.payload
		},
		setViewPreferences: (state, action: PayloadAction<ViewTypes>) => {
			state.meetingNotificationsViewPreferences = action.payload
			localStorage.setItem(
				MEETING_NOTIFICATIONS_VIEW_PREFERENCES_KEY,
				action.payload,
			)
		},
		setSortBy: (
			state,
			action: PayloadAction<MeetingNotificationsSortByOptions | null>,
		) => {
			state.sortBy = action.payload
		},
		setEmailSenderType: (
			state,
			action: PayloadAction<EmailSenderType | null>,
		) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.email_sender_type = action.payload
		},
		setCustomEmailSender: (state, action: PayloadAction<string>) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.custom_email_sender = action.payload
		},
		setReplyTo: (state, action: PayloadAction<ReplyToType | null>) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.reply_to = action.payload
		},
		setSubject: (state, action: PayloadAction<string>) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.subject = action.payload
		},
		setBody: (state, action: PayloadAction<string>) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.body = action.payload
		},
		setIsPlainText: (state, action: PayloadAction<boolean>) => {
			if (!state.meetingNotificationTemplate) return
			state.meetingNotificationTemplate.is_plain_text = action.payload
		},
		setSearch: (state, action: PayloadAction<string>) => {
			state.search = action.payload
		},
		setFilterByType: (
			state,
			action: PayloadAction<MeetingNotificationTemplateTypeEnum | null>,
		) => {
			state.filterByType = action.payload
		},
	},
})

export const meetingNotificationsTemplatesActions =
	meetingNotificationsTemplatesSlice.actions
export const meetingNotificationsTemplatesReducer =
	meetingNotificationsTemplatesSlice.reducer
